import { DownloadDocs, SpinnerCircular } from "@weirgroup/weir-dls"
import { AssetDocumentType } from "../../../types/documents.type"
import assetsApi from '../../../api/assets.api'
import FileSaver from "file-saver"
import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { useDarkMode } from "../../../hooks/use-darkmode"
interface Props {
    documents: AssetDocumentType[]
    refreshList?: () => void,
    isLoadingFetch?: boolean
}

export const Documents = (props: Props) => {
    const { documents } = props;
    const { t } = useTranslation();
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const {darkMode} = useDarkMode();
    const download = (docData: AssetDocumentType) => {
        setIsLoading(true)
        assetsApi.downloadDocs(docData.document_id).then((result: any) => {
            const file = new File(
                [result],
                docData.name,
                { type: "application/pdf" }
            );
            FileSaver.saveAs(file);
            setIsLoading(false)
        }).catch((err: any) => {
            console.error(err)
            setIsLoading(false)
        })
    }
    useEffect(() => { if (props.refreshList) props.refreshList() }, [])
    return (
        <div className="documents" data-testid="documents">
            {isLoading ? <div className="spinner">
                <SpinnerCircular darkMode={darkMode}/>
                <p style={{color:darkMode ? "white" : "black"}}>{t("loading")}</p>
            </div> : <></>}
            {documents.length > 0 ?
                <>
                    {documents.map((docs: AssetDocumentType) => {
                        return (
                            <div className="download-component" key={docs.document_id}>
                                <DownloadDocs
                                    darkMode={darkMode}
                                    key={docs.document_id}
                                    docName={docs.name}
                                    buttonTitle={t("download")}
                                    onBtnClick={() => download(docs)}
                                    applyModalInternalGrid={true}
                                    modalType={"large"}
                                />
                            </div>
                        )
                    })}
                </>
                :
                <div className="no-docs">
                    {props.isLoadingFetch ?<div className="spinner">
                    <SpinnerCircular darkMode={darkMode}/>
                    </div>:
                    <p style={{color:darkMode ? "white" : "black"}}>{t("noDocsAvailable")}</p>
                    }
                </div>
            }
        </div>
    )
}